import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { rules2x1Service } from "../../../shared/services";
import React from "react";
import { TableProperties } from "../../../shared/components/ui/Table/types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { selectproductWarehousesRefreshTable } from "../../../redux/selectors/productWarehouses.selectors";
import { useSelector } from "react-redux";
import { refreshTableAddressesUser } from "../../../redux";

const { confirm } = Modal;

export const useRemoveComboRules = () => {
  const [tableProps, setTableProps] = React.useState<TableProperties>();
  const dispatch = useAppDispatch();
  const isproductWarehousesRefreshTable= useSelector(
    selectproductWarehousesRefreshTable
  );
  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar la regla con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar regla" en caso tal solo oprime en "
          Cancelar".`,
      okText: "Borrar regla",
      okType: "danger",
      cancelText: "Cancelar",
      keyboard: true,
      maskClosable: true,
      async onOk() {
        await rules2x1Service.remove(valId)
          .then(() => {
            notify.success(
              `Se ha borrado con éxito la regla con id:${valId}`
            );
            tableProps?.refresh();

          })
          .catch((err) => {
            console.log({ err });
            notify.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (isproductWarehousesRefreshTable) {
      tableProps?.refresh();
      dispatch(refreshTableAddressesUser(false));
    }
  }, [isproductWarehousesRefreshTable]);

  return {
    showDeleteConfirm,
    setTableProps
  };
};
